export function toUTCTimezone(timestamp: number) {
  const date = new Date(timestamp);
  const utc = date.getTime() + (date.getTimezoneOffset() * 60 * 1000);
  return new Date(utc);
}
